import axios from 'axios'

const state = {
    items: []
}

const getters = {
    allItems: (state) => state.items
}

const actions = {
    async fetchItems({ commit }) {
        /* const response = await axios.get("") */
        
        commit('setItems', "nothing")
    },
    addItem({ commit }, item) {
        /* axios call */
        commit('newItem', item)
    }
}

const mutations = {
    setItems: (state, items) => (state.items = items),
    newItem: (state, item) => state.items.unshift(item)
}

export default {
    state,
    getters,
    actions,
    mutations
}